var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wild-card-info-item"},[_c('div',{staticClass:"wild-card-info-item__label"},[_vm._t("label")],2),_c('div',{staticClass:"wild-card-info-item__value ellipsis"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }